require('./document-requirements.route');
require('./document-requirement-detail.controller');
require('./document-requirement-form.controller');
